import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const shown = faqs.slice(0, 4);

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="投稿前，你可能想先知道这些"
          description="关于匿名、材料类型、反馈时间与更正流程，这里集中回答最常被问到的几个问题。"
          actionText="查看全部问答"
          actionTo="/faq"
        />
        <div className="mx-auto max-w-3xl divide-y divide-background-200 border-y border-background-200">
          {shown.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left transition-colors hover:text-primary-700"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.q}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="animate-fade-in pb-6 pr-10 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
        <p className="mx-auto mt-8 max-w-3xl text-center text-sm text-foreground-500">
          还有其他疑问？
          <Link to="/contact" className="link-underline ml-1 font-medium text-primary-600">
            直接联系我们
          </Link>
        </p>
      </div>
    </section>
  );
}

export default FaqPreview;